import React, { useState, useEffect } from 'react';
import { View } from 'react-native';
import Button, { BUTTON_TYPES } from '../Button';
import InfoItem from '../InfoItem';
import { CommonStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
const ProfileViewer = ({ profile, onEditPress, isUpdateAllowed = true }) => {
  const { tKey } = useComponentTKey('ProfileViewer');
  const { t } = useTranslation(i18nNS.me);
  const [info, setInfo] = useState({
    firstName: '',
    lastName: '',
    email: '',
    cellPhone: '',
    emergencyContact: '',
    emergencyContactNumber: '',
  });

  useEffect(() => {
    if (profile && Object.keys(profile).length > 0) {
      setInfo({
        firstName: profile.FirstName,
        lastName: profile.LastName,
        email: profile.Email,
        cellPhone: profile.CellPhone,
        emergencyContact: profile.EmergencyContact,
        emergencyContactNumber: profile.EmergencyContactPhone,
      });
    }
  }, [profile]);

  return (
    <View style={CommonStyles.p3}>
      {isUpdateAllowed ? (
        <Button
          label={t(tKey('EditProfile'))}
          type={BUTTON_TYPES.TEXT}
          iconName="edit"
          onPress={onEditPress}
        />
      ) : (
        <Button
          label="View Profile"
          type={BUTTON_TYPES.TEXT}
          iconName="eye"
          onPress={onEditPress}
        />
      )}
      <View>
        <InfoItem label={t(tKey('FirstName'))} value={info.firstName} />
        <InfoItem label={t(tKey('LastName'))} value={info.lastName} />
        <InfoItem label={t(tKey('Email'))} value={info.email} />
        <InfoItem label={t(tKey('PhoneNumber'))} value={info.cellPhone} />
        <InfoItem label={t(tKey('EmergencyContactName'))} value={info.emergencyContact} />
        <InfoItem label={t(tKey('EmergencyContactNumber'))} value={info.emergencyContactNumber} />
      </View>
    </View>
  );
};

export default ProfileViewer;
